import PropTypes from 'prop-types';
import React from 'react';
import { withTheme } from 'emotion-theming';
import createEmotionStyled from 'create-emotion-styled';
import createEmotion from 'create-emotion';
var theme = {
  baseFontSize: 16
}; //DEBTxCYBG pull this from theme component or global?

var baseSpacing = 8;

var spacing = function spacing(value) {
  var fontMultiple = value * baseSpacing;
  var rems = fontMultiple / theme.baseFontSize;
  return rems + "rem";
};

var breakpoints = {
  xs1: '0',
  xs2: '480px',
  sm1: '540px',
  sm2: '640px',
  md1: '768px',
  md2: '960px',
  lg1: '1024px',
  lg2: '1280px',
  lg3: '1328px',
  xl1: '1420px',
  xl2: '1920px'
};

var breakpoint = function breakpoint(_breakpoint) {
  return breakpoints[_breakpoint];
};

var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = createEmotion(context, {
  nonce: btoa('web-ui-components')
}),
    caches = _createEmotion.caches,
    css = _createEmotion.css,
    cx = _createEmotion.cx,
    flush = _createEmotion.flush,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    hydrate = _createEmotion.hydrate,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    merge = _createEmotion.merge,
    sheet = _createEmotion.sheet;

var emotion = /*#__PURE__*/Object.freeze({
  __proto__: null,
  caches: caches,
  css: css,
  cx: cx,
  flush: flush,
  getRegisteredStyles: getRegisteredStyles,
  hydrate: hydrate,
  injectGlobal: injectGlobal,
  keyframes: keyframes,
  merge: merge,
  sheet: sheet
});
var styled = createEmotionStyled(emotion, React);

var taggedTemplateLiteral = function taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
};

var generalPalette = {
  black: 'hsl(0, 0%, 0%)',
  blue: 'hsl(204, 52%, 48%)',
  blueLight: 'hsl(208, 59%, 60%)',
  green: 'hsl(135, 41%, 48%)',
  greenFaint: 'hsl(135, 41%, 70%)',
  greyDarkest: 'hsl(0, 0%, 28%)',
  greyDarker: 'hsl(0, 0%, 42%)',
  grey: 'hsl(0, 0%, 60%)',
  greyLighter: 'hsl(0, 0%, 75%)',
  greyLightest: 'hsl(0, 0%, 85%)',
  orange: 'hsl(29, 77%, 56%)',
  red: 'hsl(8, 52%, 50%)',
  purple: 'hsl(282, 25%, 57%)',
  white: 'hsl(0, 0%, 100%)'
};
var black = generalPalette.black,
    blue = generalPalette.blue,
    blueLight = generalPalette.blueLight,
    green = generalPalette.green,
    greenFaint = generalPalette.greenFaint,
    greyDarker = generalPalette.greyDarker,
    greyDarkest = generalPalette.greyDarkest,
    greyLightest = generalPalette.greyLightest,
    orange = generalPalette.orange,
    red = generalPalette.red,
    grey = generalPalette.grey,
    greyLighter = generalPalette.greyLighter,
    purple = generalPalette.purple,
    white = generalPalette.white;
var colours = {
  backgrounds: {
    alternateBody: 'hsl(212, 100%, 97%)',
    alternateHeader: greyLightest,
    component: white,
    modalBackdrop: black,
    modalBackdropOpaque: 'rgba(0, 0, 0, 0.8)',
    shell: 'hsl(0, 0%, 95.3%)',
    tableCell: 'hsl(0, 0%, 97%)',
    tableCellAlternate: 'hsl(0, 71%, 97%)',
    tableCellHeader: 'hsl(0, 0%, 94%)'
  },
  component: {
    border: greyLightest,
    hover: greyLightest
  },
  disabled: {
    background: greyLightest,
    border: greyDarkest
  },
  neutral: {
    black: black,
    grey: grey,
    greyDarker: greyDarker,
    greyDarkest: greyDarkest,
    greyLighter: greyLighter,
    greyLightest: greyLightest,
    white: white
  },
  telephony: {
    answerCallGradient: 'linear-gradient(hsl(54, 100%, 73%), hsl(49, 99%, 64%));',
    calledGradient: 'linear-gradient(hsl(159, 52%, 67%), hsl(153, 41%, 49%));',
    conferenceCallGradient: 'linear-gradient(hsl(193, 100%, 91%), hsl(196, 96%, 80%));',
    conferenceMaskGradient: 'linear-gradient(hsl(248, 86%, 83%), hsl(260, 94%, 72%));',
    dialingCallGradient: 'linear-gradient(hsl(54, 100%, 73%), hsl(49, 99%, 64%));',
    holdCallGradient: 'linear-gradient(hsl(45, 95%, 75%), hsl(37, 91%, 65%));',
    makeCallGradient: 'linear-gradient(hsl(33, 15%, 86%), hsl(180, 3%, 69%));',
    onCallGradient: 'linear-gradient(hsl(129, 80%, 82%), hsl(127, 67%, 63%));',
    answerCall: 'hsl(89, 91%, 40%)',
    closeCall: 'hsl(353, 98%, 41%)',
    dialCall: 'hsl(89, 91%, 40%)',
    endCall: 'hsl(353, 98%, 41%)',
    holdCall: 'hsl(37, 94%, 49%)',
    resumeCall: 'hsl(89, 91%, 40%)'
  },
  typography: {
    body: greyDarkest,
    supplementaryBody: grey
  },
  utility: {
    active: green,
    archived: greyLightest,
    blocker: 'hsl(0, 60%, 96%)',
    deprecated: 'hsl(45, 100%, 51%)',
    empty: 'hsl(0, 0%, 100%)',
    emptyBorder: 'hsl(0, 0%, 40%)',
    error: red,
    errorBodyBackground: 'hsl(8,52%,96%)',
    focus: blueLight,
    help: 'hsl(210, 38%, 91%)',
    inactive: red,
    indicative: orange,
    information: blue,
    notStarted: greyDarker,
    off: grey,
    offDisabled: greyLighter,
    ongoing: purple,
    paused: blue,
    pending: orange,
    success: green,
    successDisabled: greenFaint,
    warning: orange
  },
  utilityLegacy: {
    infoBackground: 'hsl(210, 46%, 91%)',
    infoBorder: 'hsl(204, 52%, 48%)',
    noteBackground: 'hsl(45, 53%, 94%)',
    noteBorder: 'hsl(46, 88%, 24%)',
    tipBackground: 'hsl(125, 21%, 88%)',
    tipBorder: 'hsl(135, 41%, 48%)',
    warningBackground: 'hsl(0, 60%, 96%)',
    warningBorder: 'hsl(8, 52%, 50%)'
  }
};

var _templateObject = taggedTemplateLiteral(['\n\tbox-sizing: border-box;\n\tmargin-left: auto;\n\tmargin-right: auto;\n\tmax-width: ', ';\n\tpadding: 0 ', ';\n'], ['\n\tbox-sizing: border-box;\n\tmargin-left: auto;\n\tmargin-right: auto;\n\tmax-width: ', ';\n\tpadding: 0 ', ';\n']);

var getMaxWidth = function getMaxWidth(size) {
  var maxWidth = '0';

  switch (size) {
    case 'xs':
      maxWidth = '320px';
      break;

    case 'sm':
      maxWidth = '640px';
      break;

    case 'md':
      maxWidth = '960px';
      break;

    case 'lg':
      maxWidth = '1328px';
      break;

    default:
      maxWidth = '100%';
      break;
  }

  return maxWidth;
};

var StyledWrapper = styled('div')(_templateObject, function (props) {
  return props.maxSize;
}, spacing(3));

var ContentContainer = function ContentContainer(_ref) {
  var children = _ref.children,
      size = _ref.size;
  return React.createElement(StyledWrapper, {
    maxSize: getMaxWidth(size)
  }, children);
};

ContentContainer.propTypes = {
  /** Child content as nodes. */
  children: PropTypes.node.isRequired,

  /** Container width. */
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg'])
};
ContentContainer.defaultProps = {};

ContentContainer.defaultExample = function () {
  return React.createElement(ContentContainer, null, React.createElement('span', null, React.createElement('p', null, 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.')));
};

var stringLengthConfig = {
  ContainedHeader: {
    subline: 40
  }
};
/* eslint-disable consistent-return */

/**
 * Custom validator for string of maximum length
 * @param {Object} props the full component props as object
 * @param {String} propName the prop name we are specifically checking here
 * @param {String} componentName the component name this validation is being performed on
 * @returns {Boolean} indicating successful or unsuccessful prop validation
 */

var maxLengthString = function maxLengthString(props, propName, componentName) {
  if (props[propName]) {
    var limit = stringLengthConfig[componentName][propName];
    var value = props[propName];

    if (typeof value === 'string') {
      return value.length <= limit ? null : new Error(propName + ' in ' + componentName + ' is longer than ' + limit + ' characters');
    }
  }
};

var _templateObject$1 = taggedTemplateLiteral(['\n\tbackground: ', ';\n\tbox-shadow: 0 5px 15px rgba(0, 0, 0, 0.17);\n\t', '\n\tcolor: ', ';\n\theight: 100px;\n\tposition: relative;\n\n\t> div {\n\t\theight: 100%;\n\t}\n\n\t@media (min-width: ', ') {\n\t\theight: 80px;\n\t}\n'], ['\n\tbackground: ', ';\n\tbox-shadow: 0 5px 15px rgba(0, 0, 0, 0.17);\n\t', '\n\tcolor: ', ';\n\theight: 100px;\n\tposition: relative;\n\n\t> div {\n\t\theight: 100%;\n\t}\n\n\t@media (min-width: ', ') {\n\t\theight: 80px;\n\t}\n']),
    _templateObject2 = taggedTemplateLiteral(['\n\talign-items: center;\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\theight: 100%;\n\tjustify-content: space-between;\n'], ['\n\talign-items: center;\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\theight: 100%;\n\tjustify-content: space-between;\n']),
    _templateObject3 = taggedTemplateLiteral(['\n\t', ';\n'], ['\n\t', ';\n']),
    _templateObject4 = taggedTemplateLiteral(['\n\t@media (min-width: ', ') {\n\t\tdisplay: none;\n\t}\n'], ['\n\t@media (min-width: ', ') {\n\t\tdisplay: none;\n\t}\n']),
    _templateObject5 = taggedTemplateLiteral(['\n\tdisplay: none;\n\t@media (min-width: ', ') {\n\t\tdisplay: block;\n\t}\n'], ['\n\tdisplay: none;\n\t@media (min-width: ', ') {\n\t\tdisplay: block;\n\t}\n']),
    _templateObject6 = taggedTemplateLiteral(['\n\tcolor: ', ';\n\tfont-family: ', ';\n\tfont-size: 0.875rem;\n\tline-height: 1.2;\n\tmargin: 0;\n\tmax-height: 65%;\n\tmax-width: 50%;\n\toverflow: hidden;\n\ttext-align: right;\n\t::-moz-selection {\n\t\tbackground: ', ';\n\t\tcolor: ', ';\n\t}\n\t::selection {\n\t\tbackground: ', ';\n\t\tcolor: ', ';\n\t}\n\t@media (min-width: ', ') {\n\t\tfont-size: 1.25rem;\n\t\tmax-height: 68%;\n\t}\n\t@media (min-width: ', ') {\n\t\tfont-size: 1.5625rem;\n\t\tmax-height: 75%;\n\t\tposition: relative;\n\t\ttop: 1px;\n\t}\n'], ['\n\tcolor: ', ';\n\tfont-family: ', ';\n\tfont-size: 0.875rem;\n\tline-height: 1.2;\n\tmargin: 0;\n\tmax-height: 65%;\n\tmax-width: 50%;\n\toverflow: hidden;\n\ttext-align: right;\n\t::-moz-selection {\n\t\tbackground: ', ';\n\t\tcolor: ', ';\n\t}\n\t::selection {\n\t\tbackground: ', ';\n\t\tcolor: ', ';\n\t}\n\t@media (min-width: ', ') {\n\t\tfont-size: 1.25rem;\n\t\tmax-height: 68%;\n\t}\n\t@media (min-width: ', ') {\n\t\tfont-size: 1.5625rem;\n\t\tmax-height: 75%;\n\t\tposition: relative;\n\t\ttop: 1px;\n\t}\n']);

var StyledWrapper$1 = styled('header')(_templateObject$1, function (props) {
  return props.theme.colours.headerBackground;
}, function (props) {
  return props.theme.images.headerBackgroundDesktop && props.theme.images.headerBackgroundMobile ? '\n\t\t\tbackground-image: url(' + props.theme.images.headerBackgroundMobile + ');\n\t\t\tbackground-position: center;\n\t\t\tbackground-repeat: no-repeat;\n\t\t\tbackground-size: cover;\n\t\t\t@media (min-width: ' + breakpoint('md1') + ') {\n\t\t\t\tbackground-image: url(' + props.theme.images.headerBackgroundDesktop + ');\n\t\t\t\tbackground-size: auto;\n\t\t\t}\n\t\t' : '';
}, colours.neutral.white, breakpoint('md1'));
var StyledFlexContainer = styled('div')(_templateObject2);
var logoStyles = '\n\tdisplay: block;\n\tmax-width: 45%;\n\tsvg {\n\t\tdisplay: block;\n\t\theight: 68px;\n\t\tmax-width: 100%;\n\t\twidth: auto;\n\t}\n\t@media (min-width: ' + breakpoint('md1') + ') {\n\t\tmargin: ' + spacing(2) + ' 0;\n\n\t\tsvg {\n\t\t\theight: 46px;\n\t\t\twidth: auto;\n\t\t}\n\t}\n';
var StyledLinkedLogo = styled('a')(_templateObject3, logoStyles);
var StyledUnlinkedLogo = styled('div')(_templateObject3, logoStyles);
var StyledMobileLogo = styled('div')(_templateObject4, breakpoint('md1'));
var StyledDesktopLogo = styled('div')(_templateObject5, breakpoint('md1'));
var StyledTitle = styled('h2')(_templateObject6, function (props) {
  return props.theme.colours.headerLabel;
}, function (props) {
  return props.theme.fonts.display.bold;
}, colours.neutral.white, function (props) {
  return props.theme.colours.primary;
}, colours.neutral.white, function (props) {
  return props.theme.colours.primary;
}, breakpoint('xs2'), breakpoint('md1')); // eslint-disable-next-line react/prop-types

var ContainedHeader = function ContainedHeader(_ref) {
  var href = _ref.href,
      linkTitle = _ref.linkTitle,
      theme = _ref.theme,
      subline = _ref.subline;
  return React.createElement(StyledWrapper$1, null, React.createElement(ContentContainer, {
    size: 'lg'
  }, React.createElement(StyledFlexContainer, null, href ? React.createElement(StyledLinkedLogo, {
    href: href,
    title: href && linkTitle
  }, React.createElement(StyledMobileLogo, null, theme.images.logoMobile), React.createElement(StyledDesktopLogo, null, theme.images.logoDesktop)) : React.createElement(StyledUnlinkedLogo, null, React.createElement(StyledMobileLogo, null, theme.images.logoMobile), React.createElement(StyledDesktopLogo, null, theme.images.logoDesktop)), subline && React.createElement(StyledTitle, null, subline))));
};

ContainedHeader.propTypes = {
  /** The destination for the logo link, omit this to render a non-linked logo. */
  href: PropTypes.string,

  /** This prop should be provided alongside href for accessibility. */
  linkTitle: PropTypes.string,

  /** Optional header subline text as string. Maximum of 40 characters permitted as this is all the available UI
   * space will allow. */
  subline: maxLengthString
};
ContainedHeader.defaultProps = {};
var WrappedContainedHeader = withTheme(ContainedHeader);

WrappedContainedHeader.defaultExample = function () {
  return React.createElement(WrappedContainedHeader, null);
};

export { WrappedContainedHeader as ContainedHeader };